import OrdersTable from "./OrdersTable";

export default function Canceled() {
  return <OrdersTable type="canceled" />;
}
